import React from 'react';
import PropTypes from 'prop-types';

class UploadingPopup extends React.Component {
  static propTypes = {
    importData: PropTypes.array
  };

  constructor(props) {
    super(props);
    this.state = {
      data: props.importData
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.importData
    });
  }

  mapTypeToIconClassName = type => {
    switch (type) {
      case 'workOrder':
        return 'icon-work-orders-ic';
      case 'rfs':
        return 'icon-standard-requests-ic';
      case 'purchaseOrder':
        return 'icon-purchase-orders-ic';
      default:
        return '';
    }
  };

  mapTypeToValue = type => {
    switch (type) {
      case 'workOrder':
        return 'work orders';
      case 'rfs':
        return 'requests for service';
      case 'purchaseOrder':
        return 'purchase orders';
      default:
        return '';
    }
  };

  onDismissPopupItem = index => {
    let newData = [...this.state.data];

    newData = [...newData.slice(0, index), ...newData.slice(index + 1)];

    this.setState({ data: newData });
  };

  render() {
    const { data } = this.state;

    return data.map((item, index) => {
      const typeValue = this.mapTypeToValue(item.type);
      const title = `Importing ${typeValue} to ${item.projectName}`;
      return (
        <div
          className='uploading-popup-wrapper'
          key={index}
          style={{ bottom: 25 + index * 55 }}
        >
          <i className={this.mapTypeToIconClassName(item.type)} />
          <div style={{ paddingRight: 15, marginTop: -10 }}>
            <div className='up-header' title={title}>{title}</div>
            <div className='up-loader' />
            <i
              className='pe-7s-close up-close'
              onClick={() => this.onDismissPopupItem(index)}
            />
          </div>
        </div>
      );
    });
  }
}

export default UploadingPopup;



// WEBPACK FOOTER //
// ./src/components/UploadingPopup/index.js